import React, { CSSProperties, useContext } from 'react';
import styles from './index.scss';
import { StoreContext } from '../../store';

export const ConfirmButton = () => {
  const rootStore = useContext(StoreContext);
  const { confirmButton } = rootStore.formatConfig;

  const containerStyle: CSSProperties = {
    backgroundColor: confirmButton.backgroundColor,
    height: confirmButton.height
  };
  const labelStyle: CSSProperties = {
    lineHeight: confirmButton.height + 'px'
  };

  return (
    <div
      className={styles.container}
      style={containerStyle}
      data-zone="confirm-btn"
    >
      <div className={styles.plus} data-zone="plus_button">
        <svg stroke="#676767" viewBox="0 0 64 64" width="32" height="32">
          <path
            d="M50,3A11,11,0,0,1,61,14V50A11,11,0,0,1,50,61H14A11,11,0,0,1,3,50V14A11,11,0,0,1,14,
            3H50m0-3H14A14,14,0,0,0,0,14V50A14,14,0,0,0,14,64H50A14,14,0,0,0,64,50V14A14,14,0,0,0,50,0Z"
          />
          <line x1="32" y1="16" x2="32" y2="48" fill="none" strokeWidth="5" />
          <line x1="48" y1="32" x2="16" y2="32" fill="none" strokeWidth="5" />
        </svg>
      </div>
      <div style={labelStyle} className={styles.label} data-zone="ok_button">
        <div>ok</div>
      </div>
    </div>
  );
};
